export default "__VITE_ASSET__fd417c1a__"